module.exports = __webpack_public_path__ + "img/icon-table-download.bb64e949.svg";